import { render, staticRenderFns } from "./v-order-saved-screen.vue?vue&type=template&id=cc8fd5c0&scoped=true"
import script from "./v-order-saved-screen.vue?vue&type=script&lang=js"
export * from "./v-order-saved-screen.vue?vue&type=script&lang=js"
import style0 from "./v-order-saved-screen.vue?vue&type=style&index=0&id=cc8fd5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8fd5c0",
  null
  
)

export default component.exports